import styles from "./StockRemovalReview.module.scss";
import secondaryComponents from "../../../../../components/secondaryComponents";
import primaryComponents from "../../../../../components/primaryComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Icon from "../../../../../assets/icons";

export const StockRemovalReviewActions = ({
  isPending = false,
  isDraft = false,
  isApproving = false,
  isRejecting = false,
  isDeleting = false,
  isSubmittingDraft = false,
  setIsApproveModalOpen,
  setIsRejectModalOpen,
  setIsDeleteModalOpen,
  setIsEditDraftModalOpen,
  handleSubmitDraft,
  onApprove,
  onReject,
  onDelete,
  onEditDraft,
  onSubmitDraft,
}) => {
  const handleApprove = () => {
    if (onApprove) {
      onApprove();
    } else if (setIsApproveModalOpen) {
      setIsApproveModalOpen(true);
    }
  };

  const handleReject = () => {
    if (onReject) {
      onReject();
    } else if (setIsRejectModalOpen) {
      setIsRejectModalOpen(true);
    }
  };

  const handleDelete = () => {
    if (onDelete) {
      onDelete();
    } else if (setIsDeleteModalOpen) {
      setIsDeleteModalOpen(true);
    }
  };

  const handleEditDraft = () => {
    if (onEditDraft) {
      onEditDraft();
    } else if (setIsEditDraftModalOpen) {
      setIsEditDraftModalOpen(true);
    }
  };

  const handleSubmit = () => {
    if (onSubmitDraft) {
      onSubmitDraft();
    } else if (handleSubmitDraft) {
      handleSubmitDraft();
    }
  };

  return (
    <div className={styles.stockRemovalReview__actions}>
      {isPending && (
        <>
          <secondaryComponents.NavigateWithPermission
            permissionParentKey={"Inventory Management"}
            permissionChildKey="can_approve_stock_removal"
          >
            <primaryComponents.Button
              classNames="btn btn--primary mr-2"
              onClick={handleApprove}
              isDisabled={isApproving}
            >
              <img src={Icon.like} alt="approve" className="mr-2" />
              Approve
            </primaryComponents.Button>
            <primaryComponents.Button
              classNames="btn btn--outline-red mr-2"
              onClick={handleReject}
              isDisabled={isRejecting}
            >
              <FontAwesomeIcon icon="times" className="mr-2" />
              Reject
            </primaryComponents.Button>
          </secondaryComponents.NavigateWithPermission>

          <secondaryComponents.NavigateWithPermission
            permissionParentKey={"Inventory Management"}
            permissionChildKey="can_remove_products"
          >
            <primaryComponents.Button
              classNames="btn btn--outline-red"
              onClick={handleDelete}
              isDisabled={isDeleting}
            >
              Delete
            </primaryComponents.Button>
          </secondaryComponents.NavigateWithPermission>
        </>
      )}

      {isDraft && (
        <secondaryComponents.NavigateWithPermission
          permissionParentKey={"Inventory Management"}
          permissionChildKey="can_remove_products"
        >
          <primaryComponents.Button
            classNames="btn btn--outline-green mr-2"
            onClick={handleEditDraft}
          >
            Continue Draft
          </primaryComponents.Button>

          <primaryComponents.Button
            classNames="btn btn--primary mr-2"
            onClick={handleSubmit}
            isLoading={isSubmittingDraft}
            loadingText="Submitting..."
          >
            Submit for Approval
          </primaryComponents.Button>

          <primaryComponents.Button
            classNames="btn btn--outline-red"
            onClick={handleDelete}
            isDisabled={isDeleting}
          >
            Delete Draft
          </primaryComponents.Button>
        </secondaryComponents.NavigateWithPermission>
      )}
    </div>
  );
};

export default StockRemovalReviewActions;
